import { useSelector } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import FinalChecklist from './final-checklist';
import { TALKIATRY_PHONE_NUMBER_DISPLAY } from '../../../helpers/const';
import { selectMedicalInfoAnswers } from '../../../redux/assessment';
import { FinalWithBookingWidget } from './final-with-booking-widget';
import { useLDFlags } from '../../providers/ld-flags';
import { AssessmentButtons, AssessmentCard } from '../shared';
import ZocdocNotAMatchAlert from './zocdoc-not-a-match-alert';
import ZocdocCancellationAlert from './zocdoc-cancellation-alert';
import { selectLdFlags } from '../../../redux/ld-flags';

export const FinalNoMatchesReturned = () => {
  const { shouldUseIntakeV2Point1 } = useSelector(selectLdFlags);

  const PARAGRAPH_ONE =
    'Thanks for completing your assessment. We’re almost ready to get you matched.';
  const PARAGRAPH_TWO =
    'The next step is a quick call with one of our care coordinators. We’ll ask you a few follow-up questions (be sure to have your insurance card handy) and help you schedule your first visit.';

  return (
    <FinalWithBookingWidget>
      <Stack spacing={1}>
        <ZocdocNotAMatchAlert />
        <ZocdocCancellationAlert />
        {shouldUseIntakeV2Point1 ? (
          <Typography paragraph>
            Pick a time and we'll give you a call
          </Typography>
        ) : (
          <>
            <Typography paragraph>{PARAGRAPH_ONE}</Typography>
            <Typography paragraph>{PARAGRAPH_TWO}</Typography>
          </>
        )}
      </Stack>
    </FinalWithBookingWidget>
  );
};

export const FinalWithoutMatching = () => (
  <>
    <AssessmentCard>
      <Typography paragraph>
        While we are currently improving our online patient to psychiatrist
        matching,{' '}
        <strong>
          our team will contact you by telephone within 72 hours to schedule an
          appointment.
        </strong>
      </Typography>
      <Typography paragraph>
        We’ll review your assessment and match you with a psychiatrist that best
        suits your treatment needs.{' '}
        <strong>
          Typically, you can be seen by a psychiatrist within 48 hours after we
          speak to you.
        </strong>
      </Typography>
      <Typography paragraph>
        We will call you from {TALKIATRY_PHONE_NUMBER_DISPLAY} and may come up
        on your caller ID as Talkiatry Management Services.
      </Typography>
      <Typography>Thank you for choosing Talkiatry!</Typography>
    </AssessmentCard>
    <AssessmentButtons
      primary={{
        children: 'Return to Talkiatry.com',
        href: 'https://talkiatry.com/',
        endIcon: undefined,
      }}
    />
  </>
);

const Final = () => {
  const { bookingWidgetEnabled } = useLDFlags();
  const { MI_HaveAppointment } = useSelector(selectMedicalInfoAnswers);

  if (MI_HaveAppointment?.includes('Yes')) {
    return <FinalChecklist />;
  }
  return bookingWidgetEnabled ? (
    <FinalNoMatchesReturned />
  ) : (
    <FinalWithoutMatching />
  );
};

export default Final;
